import { useParams, Link } from 'react-router-dom';
import Helmet from '@/components/base/Helmet';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, hotArticles } from '@/mocks/site';

const CAT_IMG_WANGHONG = 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20crisis%20concept%2C%20smartphone%20falling%20into%20water%20with%20dramatic%20splash%2C%20dark%20moody%20background%20with%20red%20notification%20lights%2C%20editorial%20photography%20with%20intense%20dramatic%20lighting%20and%20cinematic%20composition&width=400&height=300&seq=cat-wanghong&orientation=landscape';
const CAT_IMG_MINGXING = 'https://readdy.ai/api/search-image?query=Leaked%20celebrity%20messages%20concept%2C%20glowing%20chat%20bubbles%20floating%20in%20dark%20void%2C%20mysterious%20atmosphere%20with%20blue%20and%20red%20digital%20tones%2C%20cinematic%20thriller%20aesthetic%20with%20floating%20text%20fragments&width=400&height=300&seq=cat-mingxing&orientation=landscape';
const CAT_IMG_BOZHU = 'https://readdy.ai/api/search-image?query=Split%20personality%20concept%20with%20two%20contrasting%20masks%20side%20by%20side%2C%20one%20elegant%20and%20one%20chaotic%2C%20dramatic%20theatrical%20lighting%2C%20dark%20stage%20setting%20with%20spotlight%2C%20editorial%20photography%20with%20strong%20visual%20contrast&width=400&height=300&seq=cat-bozhu&orientation=landscape';
const CAT_IMG_51 = 'https://readdy.ai/api/search-image?query=Multiple%20watermelon%20slices%20arranged%20dramatically%20on%20dark%20table%20with%20breaking%20news%20headlines%20projected%20onto%20them%2C%20creative%20food%20photography%20with%20red%20and%20green%20contrast%2C%20editorial%20journalism%20concept%20with%20dramatic%20lighting&width=400&height=300&seq=cat-51chigua&orientation=landscape';
const CAT_IMG_17 = 'https://readdy.ai/api/search-image?query=Fire%20and%20ice%20dramatic%20contrast%20concept%2C%20burning%20newspaper%20headlines%20floating%20above%20frozen%20ground%2C%20intense%20editorial%20photography%20with%20warm%20flames%20against%20cool%20dark%20background%2C%20powerful%20storytelling%20visual&width=400&height=300&seq=cat-17chigua&orientation=landscape';
const CAT_IMG_SHEHUI = 'https://readdy.ai/api/search-image?query=Social%20media%20radar%20scanning%20concept%2C%20multiple%20red%20alert%20pins%20on%20dark%20digital%20map%2C%20cybersecurity%20monitoring%20aesthetic%2C%20dramatic%20red%20glow%20on%20dark%20interface%2C%20editorial%20technology%20journalism%20photography&width=400&height=300&seq=cat-shehui&orientation=landscape';
const CAT_IMG_ZHIBO = 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20disaster%20concept%2C%20ring%20light%20falling%20dramatically%20with%20sparks%2C%20shocked%20expression%20captured%20in%20mirror%20reflection%2C%20intense%20editorial%20photography%20with%20dramatic%20lighting%20and%20chaos&width=400&height=300&seq=cat-zhibo&orientation=landscape';
const CAT_IMG_MEIRI = 'https://readdy.ai/api/search-image?query=Golden%20trophy%20surrounded%20by%20dramatic%20red%20spotlights%20on%20dark%20stage%2C%20competition%20winner%20concept%2C%20theatrical%20awards%20show%20atmosphere%20with%20fog%20and%20intense%20lighting%2C%20cinematic%20editorial%20photography&width=400&height=300&seq=cat-meiri&orientation=landscape';

const catImages: Record<string, string> = {
  'wanghong-tafang': CAT_IMG_WANGHONG,
  'mingxing-liaotian': CAT_IMG_MINGXING,
  'bozhu-fancha': CAT_IMG_BOZHU,
  '51chigua': CAT_IMG_51,
  '17chigua': CAT_IMG_17,
  'shehui-redian': CAT_IMG_SHEHUI,
  'zhibo-fanche': CAT_IMG_ZHIBO,
  'meiri-dasai': CAT_IMG_MEIRI,
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="pt-20 pb-20 text-center">
          <p className="text-foreground-600">分类不存在</p>
          <Link to="/" className="text-primary-600 hover:underline mt-2 inline-block">返回首页</Link>
        </div>
        <Footer />
      </>
    );
  }

  const articles = hotArticles.filter((a) => a.categorySlug === slug);
  const displayArticles = articles.length > 0 ? articles : hotArticles.slice(0, 6);

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'http://mengwenquda.cn/' },
      { '@type': 'ListItem', position: 2, name: category.name, item: `http://mengwenquda.cn/category/${slug}` },
    ],
  };

  return (
    <>
      <Helmet title={`${category.name} - 黑料爆料吃瓜网`} />
      <Helmet>
        {`<meta name="description" content="${category.description} - 黑料爆料吃瓜网${category.name}专区，最新最全的${category.name}内容一网打尽。" />`}
        {`<meta name="keywords" content="${category.name},黑料爆料,吃瓜网,51吃瓜,17c吃瓜,网红塌房,明星聊天记录,博主反差" />`}
        {`<link rel="canonical" href="http://mengwenquda.cn/category/${slug}" />`}
        {`<script type="application/ld+json">${JSON.stringify(breadcrumbSchema)}</script>`}
      </Helmet>

      <Navbar />

      <main>
        <div className="relative w-full h-[320px] md:h-[400px] overflow-hidden">
          <img
            src={catImages[slug as string] || CAT_IMG_51}
            alt={category.name}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
          <div className="relative z-10 h-full flex flex-col justify-center px-4 md:px-6 pt-16">
            <div className="max-w-7xl mx-auto w-full">
              <nav className="flex items-center gap-2 text-white/60 text-xs mb-4 flex-wrap">
                <Link to="/" className="hover:text-white transition-colors whitespace-nowrap">首页</Link>
                <i className="ri-arrow-right-s-line text-[10px]"></i>
                <span className="text-white font-medium whitespace-nowrap">{category.name}</span>
              </nav>
              <h1 className="font-heading text-2xl md:text-4xl font-black text-white">
                {category.name}
              </h1>
              <p className="text-white/70 text-sm mt-2 max-w-lg">
                {category.description}
              </p>
            </div>
          </div>
        </div>

        <div className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {displayArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all"
                >
                  <div className="relative h-48">
                    <img
                      src={catImages[article.categorySlug] || CAT_IMG_51}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      title={article.title}
                    />
                    <div className="absolute top-3 left-3 flex gap-2 flex-wrap">
                      <span className="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-primary-500 text-white whitespace-nowrap">
                        {article.category}
                      </span>
                      {article.isNew && (
                        <span className="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-accent-500 text-white whitespace-nowrap">
                          NEW
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="font-semibold text-sm text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-600 mt-2 line-clamp-2">{article.excerpt}</p>
                    <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500 flex-wrap">
                      <span className="whitespace-nowrap">{article.date}</span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-eye-line text-[10px]"></i> {article.views.toLocaleString()}
                      </span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-chat-3-line text-[10px]"></i> {article.comments.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}